import styled from "styled-components";
import {
  screenSize,
  whiteColor,
  inputBackgroundColor,
  inputBorderColor,
  mediumFont,
  inputBackgroundHoverColor,
  primaryColor,
  dangerColor,
  labelColor,
} from "@app/styles";
export const InputRowContainer = styled.div`
  margin-bottom: 16px;
  input[type=password]::-ms-reveal, 
  input[type=password]::-ms-clear
   { 
     display: none;
   }
`;
export const InputContainer = styled.div`
  position: relative;
  // margin-bottom: 20px;
  .password-icon {
    position: absolute;
    right: 12px;
    width: 20px !important;
    top: 15px;
    color: #979cab;
  }
  &.with-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .password-icon {
      right: 60px;
    }
  }

  .info-icon {
    cursor: pointer;
    margin-right: 0px;
    font-size: 18px;
    border: 2px solid;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    padding: 4px;
  }
`;

export const InputComponent = styled.input`
  width: 100%;
  height: 44px;
  padding: 2px 44px 2px 16px;
  border: 2px solid ${whiteColor};
  background-color: ${inputBackgroundColor};
  border-color: ${inputBorderColor};
  border-radius: 6px;
  color: #2d3448;
  box-shadow: none;
  outline: none;
  -webkit-appearance: none;
  font-size: 14px;
  transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  input[type=password]::-ms-reveal, 
  input[type=password]::-ms-clear {
    display: none;
  }
  
  &.with-info {
    width: calc(100% - 34px);
  }
  @media (${screenSize.tablet}) {
    &:hover {
      background-color: ${inputBackgroundHoverColor};
    }
    &:active,
    &:focus {
      background-color: ${whiteColor};
      border-color: ${primaryColor};
    }
  }
`;

export const Label = styled.label`
  display: block;
  font-family: "Filson";
  font-size: 14px;
  letter-spacing: 0.03em;
  color: ${labelColor};
  ${mediumFont};
  line-height: 1.25;
  margin-bottom: 4px;
  &.hide {
    display: none;
  }
`;
export const PopoverLeft = styled.div`
  position: absolute;
  right: 30px;
  background: #fff;
  line-height: 20px;
  padding: 10px;
  border-radius: 7px;
  border: 1px solid #00be9a;
  font-size: 12px;
`;

export const Instructions = styled.div`
margin-top: 4px;
p{
  line-height: 1.5;
  font-size: 12px;
  margin: 0;
  opacity: 0.65;
  span{
    color: ${dangerColor};
  }
}
`